<template>
  <section class="publish-section">
    <el-form label-position="right" :rules="publishInfoRules" :ref="formRef" :model="contentInfo" label-width="130px">
      <el-form-item label="标题：" prop="title">
        <el-input v-model="contentInfo.title" maxlength="250"></el-input>
      </el-form-item>
      <el-form-item label="封面：" prop="poster">
        <el-upload
          class="avatar-uploader"
          action="/appeal/file/upload/productPoster"
          :show-file-list="false"
          :on-success="handleAvatarSuccess">
          <img v-if="contentInfo.poster" :src="contentInfo.poster" class="avatar">
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </el-form-item>
      <el-form-item label="发布正文：" prop="content" style="height: 350px">
        <quill-editor
          class="ql-editor-class"
          style="height: 300px"
          v-model="contentInfo.content"
          ref="myQuillEditor"
          :options="editorOption"
          @blur="onEditorBlur($event)"
          @focus="onEditorFocus($event)"
          @change="onEditorChange($event)">
        </quill-editor>
      </el-form-item>
      <el-form-item label="上传附件">
        <el-upload
          class="upload-demo"
          action="/appeal/file/upload/productAttachment"
          :on-success="handleAttachmentSuccess"
          :on-remove="handleRemove"
          multiple
          :file-list="fileList">
          <el-button icon="el-icon-upload" type="main">点击上传</el-button>
        </el-upload>
      </el-form-item>
    </el-form>
    <div class="publish-control">
      <el-button size="small" type="info" @click="handleCancel">取 消</el-button>
      <el-button size="small" type="main" @click="handleSave">保 存</el-button>
    </div>
  </section>
</template>
<script>
  import "quill/dist/quill.core.css"
  import "quill/dist/quill.snow.css"
  import "quill/dist/quill.bubble.css"
  import { quillEditor } from "vue-quill-editor"
  import { addDynamicDuty, getDynamicDuty, updateDynamicDuty } from '@/api/restapi.js'
  const toolbarOptions = [
    ["bold", "italic", "underline", "strike"], // 加粗 斜体 下划线 删除线 -----['bold', 'italic', 'underline', 'strike']
    // ["blockquote", "code-block"], // 引用  代码块-----['blockquote', 'code-block']
    [{ list: "ordered" }, { list: "bullet" }], // 有序、无序列表-----[{ list: 'ordered' }, { list: 'bullet' }]
    [{ 'header': 1 }, { 'header': 2 }],
    [{ script: "sub" }, { script: "super" }], // 上标/下标-----[{ script: 'sub' }, { script: 'super' }]
    // [{ indent: "-1" }, { indent: "+1" }],
    [{ size: ['small', false, 'large', 'huge']}], // 配置字号
    // [{ header: [1, 2, 3, 4, 5, 6, false] }], // 标题-----[{ header: [1, 2, 3, 4, 5, 6, false] }]
    [{ color: [] }, { background: [] }], // 字体颜色、字体背景颜色-----[{ color: [] }, { background: [] }]
    // [{ font: []}], //显示字体选择
    [{ align: [] }], // 对齐方式-----
    ["clean"], // 清除文本格式-----
    ['link', 'image'], // 链接、图片、视频-----, 'video'
  ]
  export default {
    components: { quillEditor },
    data () {
      return {
        editorOption: {
          theme: "snow",
          placeholder:"输入正文",
          modules: {
            toolbar: toolbarOptions,
          }
        },
        publishInfoRules: {
          title: [
            { required: true, message: '请填写标题', trigger: 'blur' }
          ],
          // poster: [
          //   { required: true, message: '请上传封面', trigger: 'blur' }
          // ],
          content: [
            { required: true, message: '请填写内容', trigger: 'blur' }
          ]
        },
        formRef: 'publishDetailForm',
        fileList: [],
        contentInfo: {
          id: '',
          title: '',
          poster: '',
          content: '',
          attachments: []
        },
        onEditorBlur() {
          //失去焦点事件
        },
        onEditorFocus() {
          //获得焦点事件
        },
        onEditorChange() {
          //内容改变事件
        }
      }
    },
    mounted () {
      if (this.$route.query.id) {
        getDynamicDuty(this.$route.query.id).then(res => {
          if (res.data.code === 0){
            this.contentInfo = Object.assign({},res.data.data)
            if (this.contentInfo.attachments) {
              this.contentInfo.attachments.forEach(file => {
                this.fileList.push({
                  name: file.fileName,
                  response: {
                    data: file.fileUrl
                  }
                })
              })
            }
          }
        })
      }
    },
    methods: {
      handleAvatarSuccess (res, file) {
        this.contentInfo.poster = file.response.data//URL.createObjectURL(file.raw)
      },
      handleAttachmentSuccess (res, file) {
        this.contentInfo.attachments.push({
          fileName: file.name,
          fileUrl: file.response.data
        })
      },
      handleRemove (res, file) {
        let att = []
        file.forEach(f => {
          att.push({
            fileName: f.name,
            fileUrl: f.response.data
          })
        })
        this.contentInfo.attachments = att
      },
      handleCancel () {
        this.$router.go(-1)
      },
      handleSave () {
        let isValid = true
        this.$refs[this.formRef].validate((valid) => {
          if (!valid) {
            isValid = false
          }
        })
        if (!isValid) {
          this.$message({
            showClose: true,
            message: '请检查填写内容',
            type: 'error'
          })
          return
        }
        let execFun = addDynamicDuty
        if (this.contentInfo.id) {
          execFun = updateDynamicDuty
        }
        execFun(this.contentInfo).then(res => {
          if (res.data.code === 0) {
            this.$message({
              showClose: true,
              message: '操作成功',
              type: 'success'
            })
            this.$router.go(-1)
          } else {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'error'
            })
          }
        }).catch(err => {
          this.$message({
            showClose: true,
            message: '系统异常',
            type: 'error'
          })
        })
      }
    }
  }
</script>
<style scoped>
  @import "../style/Table.css";
  .publish-section {
    background: #FFFFFF;
    padding: 10px;
  }
  .ql-editor-class {
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    line-height: 1.42;
    height: 100%;
    outline: none;
    padding: 0 !important;
    tab-size: 4;
    -moz-tab-size: 4;
    text-align: left;
    word-wrap: break-word;
  }
  .ql-snow .ql-picker.ql-size .ql-picker-label::before,
  .ql-snow .ql-picker.ql-size .ql-picker-item::before {
    content: '默认' !important;
  }
  .ql-snow .ql-picker.ql-size .ql-picker-label[data-value=small]::before,
  .ql-snow .ql-picker.ql-size .ql-picker-item[data-value=small]::before {
    content: '小号' !important;
  }
  .ql-snow .ql-picker.ql-size .ql-picker-label[data-value=large]::before,
  .ql-snow .ql-picker.ql-size .ql-picker-item[data-value=large]::before {
    content: '大号' !important;
  }
  .ql-snow .ql-picker.ql-size .ql-picker-label[data-value=huge]::before,
  .ql-snow .ql-picker.ql-size .ql-picker-item[data-value=huge]::before {
    content: '特大号'!important;
  }
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 100%;
    height: 178px;
    display: block;
  }
  .publish-control{
    width: 100%;
    text-align: center;
  }
  .publish-control .el-button{
    width: 100px;
    margin-left: 20px;
    margin-right: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/PublishDetail.vue